import { render, staticRenderFns } from "./StakingBSCPool.vue?vue&type=template&id=0356dbac&scoped=true&"
import script from "./StakingBSCPool.vue?vue&type=script&lang=js&"
export * from "./StakingBSCPool.vue?vue&type=script&lang=js&"
import style0 from "./StakingBSCPool.vue?vue&type=style&index=0&id=0356dbac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356dbac",
  null
  
)

export default component.exports